import { defineMessages } from "@formatjs/intl"
import type { ImageStatus } from "./ImageStatus"

export const imageStatusMessages = defineMessages<ImageStatus | "uncategorizedImagesCount">({
	complete: {
		defaultMessage: "Complete",
		id: "vehicleMediaList.imageStatus.complete",
	},
	"incorrect-images": {
		defaultMessage: "Incorrect images",
		id: "vehicleMediaList.imageStatus.incorrectImages",
	},
	"not-enough-images": {
		defaultMessage: "Not enough images",
		id: "vehicleMediaList.imageStatus.tooFewImages",
	},
	"uncategorized-images": {
		defaultMessage: "Uncategorized images",
		id: "vehicleMediaList.imageStatus.uncategorizedImages",
	},
	uncategorizedImagesCount: {
		defaultMessage: "Uncategorized images ({number})",
		id: "vehicleMediaList.imageStatus.uncategorizedImagesCount",
	},
})
